import React from "react";
import { Route, Routes } from "react-router-dom";
import CFApprovalv2Home from "../components/cf-approval-v2-home";
import CfApprovalv2PrivateRoutes from "./private-route";
import CfV2FormDetails from "../components/cf-v2-form-details";
import CfV2AffixSignature from "../components/cf-v2-affix-signature";
import CapexCalculatorPage from "../components/capex-calculator/capex-calculator-page";

const CFApprovalV2Routes = () => {
  return (
     <Routes>
      <Route exact path='/' element={<CfApprovalv2PrivateRoutes />}>
        <Route exact path='/' element={<CFApprovalv2Home />} />
        <Route path='/form-details/:id' element={<CfV2FormDetails />} />
        <Route path='/affix-signature/:id' element={<CfV2AffixSignature />} />
        <Route path='/capex-calculator/:cfId' element={<CapexCalculatorPage />} />
      </Route>
    </Routes>
  );
};

export default CFApprovalV2Routes;
